import { render } from "./OrderMeta.vue?vue&type=template&id=4b2c0f7f"
import script from "./OrderMeta.vue?vue&type=script&lang=js"
export * from "./OrderMeta.vue?vue&type=script&lang=js"

import "./OrderMeta.vue?vue&type=style&index=0&id=4b2c0f7f&lang=css"
script.render = render

export default script